import { BfxDialogCommand } from "./bfx-dialog-command.enum";

export class BfxDialogData {
  private _body: Element;

  public get body(): Element {
    let bodyElement: HTMLElement;

    if (this.event != null) {
      // prefer triggering event's body as it may be in different openfin window
      bodyElement = this.event?.currentTarget?.ownerDocument?.body;
    }

    if (bodyElement != null) {
      return bodyElement;
    }

    return this._body;
  }

  public set body(value) {
    this._body = value;
  }

  constructor(
    public command: BfxDialogCommand,
    public dialogId: string | null,
    public event: any,
    public payload: any | null,
    body?: Element | null,
  ) {
    this._body = body;
  }
}
